<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/">
        <i class="fa fa-home"></i>
        Home
      </b-breadcrumb-item>
      <b-breadcrumb-item active>NIS</b-breadcrumb-item>
      <b-breadcrumb-item active>Data Dashboard</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="card">
      <div class="card-header">
          <ul class="card-header-tabs nav nav-tabs">
              <li class="nav-item">
                  <a @click="currentTabComponent='TheAllDBsDashboard'" class="active nav-link"
                      data-toggle="tab"
                      href="#">All DBs</a>
              </li>
              <li class="nav-item">
                  <a @click="currentTabComponent='TheFAMISDBDashboard'" class="nav-link"
                      data-toggle="tab"
                      href="#">FAMIS DB</a>
              </li>
          </ul>
      </div>
      <div id="tab-container">
          <keep-alive>
              <component v-bind:is="currentTabComponent"/>
          </keep-alive>
      </div>
    </div>
  </div> 
</template>

<script>
  import TheAllDBsDashboard from '@/components/dashboards/TheAllDBsDashboard.vue';
  import TheFAMISDBDashboard from '@/components/dashboards/TheFAMISDBDashboard.vue';

export default {
  components: {
    TheAllDBsDashboard,
    TheFAMISDBDashboard
  },
  data() {
    return {
      currentTabComponent: 'TheAllDBsDashboard'
    }
  }
};
</script>